import { render, staticRenderFns } from "./VIPinfo.vue?vue&type=template&id=0fd1a470&scoped=true&"
import script from "./VIPinfo.vue?vue&type=script&lang=js&"
export * from "./VIPinfo.vue?vue&type=script&lang=js&"
import style0 from "./VIPinfo.vue?vue&type=style&index=0&id=0fd1a470&prod&lang=scss&"
import style1 from "./VIPinfo.vue?vue&type=style&index=1&id=0fd1a470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1a470",
  null
  
)

export default component.exports